var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"user-avatar",class:{ big: _vm.big }},[(_vm.user.avatar)?_c('img',{attrs:{"src":`${_vm.uploads}/avatars/${_vm.user.avatar}`}}):_c('span',[_vm._v(_vm._s(_vm.firstLastLetters))])])
}
var staticRenderFns = []

export { render, staticRenderFns }